module.exports = __webpack_public_path__ + "static/media/ice17.873e483d.webp";